/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import './NxTable.scss'
import {
  TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Modal, ModalBody,
  FormGroup, Input, Label, Button, Form, FormFeedback, CustomInput, ModalFooter, Container,
} from 'reactstrap'
import Select from 'react-select'
import { I18n } from 'react-redux-i18n'
import { company, EcommerceAPI } from '../../api'
import InsuranceOptions from './InsuranceOptions'
import TextEditor2 from 'components/Form/TextEditor/TextEditor2'
import { useDispatch, useSelector } from 'react-redux'
import TemporaryRecord from 'redux/temporaryRecord/actions'
import URLUtils from 'utils/URLUtils'

const { credentials: credentialsApi } = company

export default function CredentialTab(props) {
  if (!Object.keys(props.schema).length) return null

  const lockedInherit = true
  const dispatch = useDispatch()
  const defaultCredential = { isEnabled: false, description: '', value: {} }
  const [status, setStatus] = useState({ css: '', message: '', hidden: true })
  const [activeTab, setActiveTab] = useState(0) // define which tab to show
  const [config, setConfig] = useState({ credentialsOptions: [] })
  const [credentials, setCredentials] = useState([])
  const [schema, setSchema] = useState({})
  const [credential, setCredential] = useState({ value: {}, isEnabled: false })
  const [errors, setErrors] = useState({})
  const [lockedButtons, setLockedButtons] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const modules = useSelector(state => state.modules)

  const isEcommerce = credentials?.[activeTab]?.hub === 'ecommerce'

  useEffect(() => {
    if (props.credentials.length) {
      setCredentials(props.credentials)
      setCredential(props.credentials[0])
    }
    setLockedButtons(props.lockedButtons)
    setSchema(props.schema.schema)
    setActiveTab(0)
  }, [props.credentials])

  useEffect(() => {
    getCredentialsByCompanyAndOrBrand()
  }, [props.brandSelected, props.delegationSelected])

  const userCanReadOnly = props.schema.backListRoles.includes(props.userRole)

  const getCredentialsByCompanyAndOrBrand = () => {
    const {
      brandSelected: brand,
      delegationSelected: delegation,
      schema: { key, type },
    } = props

    credentialsApi
      .getCredentialsByKey({ key, type, brand, delegation })
      .then(({ data, status }) => {
        if (status === 200) {
          if (data.toInherit.length) {
            let credentialsOptions = [].concat(
              data.toInherit.map((credential) => ({
                value: credential,
                label: credential.description,
              }))
            )
            setConfig({ ...config, credentialsOptions })
          }

          const size = data.results.length
          const index = activeTab === 0 ? 0 : activeTab >= size - 1 ? size - 1 : activeTab

          setCredential(size ? data.results[index] : defaultCredential)
          setSchema(data.schema.schema)
          setCredentials(data.results)
          setActiveTab(index)
        }
      })
      .catch(console.error)
      .finally(() => {
        props.updateStatus()
        setLockedButtons(false)
      })
  }

  const validateInputs = () => {
    let errors = {},
      status = true
    for (let prop in schema) {
      if (schema[prop].required && (schema[prop].value || schema[prop].content)) {
        credential.value[prop] = schema[prop].value || schema[prop].content
      } else if (schema[prop].required && !credential.value[prop]) {
        errors[prop] = true
        status = false
      } else {
        errors[prop] = false
      }
    }
    setErrors(errors)
    return status
  }

  const infoMessage = (type) => {
    let hidden = false
    switch (type) {
      case 'success':
        setStatus({
          css: 'text-primary',
          message: I18n.t('dashboard_credentials-saved'),
          hidden,
        })
        break
      case 'error':
        setStatus({
          css: 'text-danger',
          message: I18n.t('dashboard_credentials-unrecognized'),
          hidden,
        })
        break
      case 'warning':
        setStatus({
          css: 'text-warning',
          message: I18n.t('dashboard_credentials-configure-products'),
          hidden,
        })
        break
      case 'verify':
        setStatus({
          css: 'text-secondary',
          message: I18n.t('dashboard_credentials-verifying'),
          hidden,
        })
        break
      case 'pluginEcommerce':
        setStatus({
          css: 'text-warning',
          message: I18n.t('credential_deactivate_msg_plugin_ecommerce'),
          hidden,
        })
        break
      case 'smartChatEcommerce':
        setStatus({
          css: 'text-warning',
          message: I18n.t('credential_deactivate_msg_smart_chat_ecommerce'),
          hidden,
        })
        break
      default:
    }
    setTimeout(() => setStatus({ hidden: true }), 4000)
  }

  const handleSubmit = async (e) => {
    try {
      setLockedButtons(true)
      e.preventDefault()

      if (validateInputs()) {
        infoMessage('verify')

        let newCredential = Object.assign({}, credential)

        delete newCredential.schema
        delete newCredential.logo
        delete newCredential.listPolicies

        if (!newCredential._id) {
          newCredential.brand = props.brandSelected
          newCredential.delegation = props.delegationSelected
          newCredential.key = props.schema.key
          newCredential.type = props.schema.type
          newCredential.hub = props.schema.hub

          await credentialsApi.createCredentials(newCredential)
        } else {
          await credentialsApi.updateCredentials(newCredential)
        }
        infoMessage('success')
        getCredentialsByCompanyAndOrBrand()
      }
    } catch (e) {
      console.error(e.stack)
      infoMessage('error')
    } finally {
      setLockedButtons(false)
    }
  }

  const ecommerceCredentialHandler = async () => {
    try {
      setLockedButtons(true)

      if (validateInputs()) {
        let newCredential = Object.assign({}, credential)

        delete newCredential.schema
        delete newCredential.logo
        delete newCredential.listPolicies

        newCredential.isEnabled = true
        try {
          newCredential.value.domain = new URLUtils(newCredential.value.domain).hostname
        } catch(error) {
          setErrors({ domain: true })

          infoMessage('error')

          return
        }

        infoMessage('verify')

        if (!newCredential._id) { // is new
          newCredential.key = props.schema.key
          newCredential.type = props.schema.type
          newCredential.hub = props.schema.hub

          dispatch(TemporaryRecord.add({ pluginEcommerce: newCredential }))

          await EcommerceAPI.getShopifyURL({ domain: newCredential.value.domain, key: newCredential.key })
        } else {
          await credentialsApi.updateCredentials(newCredential)
          infoMessage('success')
        }
      }
    } catch ({ message, response, stack }) {
      const data = response?.data || {}
      if (data.type !== 'flow') {
        console.error(data, message, stack)

        infoMessage('error')
      }
    } finally {
      setLockedButtons(false)
    }
  }

  const handleChange = ({ target }) =>
    setCredential({
      ...credential,
      value: { ...credential.value, [target.name]: target.value },
    })

  const handleAddTab = () => {
    if (credentials.length && credentials.every((credential) => credential._id)) {
      let newCredentials = credentials.concat(defaultCredential)
      let index = newCredentials.length - 1
      setCredentials(newCredentials)
      setCredential(newCredentials[index])
      setActiveTab(index)
    }
  }

  const onDeleteTab = async (e, index) => {
    try {
      e.stopPropagation()
      setLockedButtons(true)
      if (credentials[index]._id) {
        if (credentials[index].type === 'ecommerce') {
          await EcommerceAPI.closeShop(credentials[index]._id)
        } else {
          await credentialsApi.deleteCredentials(credentials[index])
        }
      }

      setShowModal(false)
      getCredentialsByCompanyAndOrBrand()
      setLockedButtons(false)
      props.updateStatus()
      props.onToggleActive()
    } catch (e) {
      console.error(e.stack)
      setShowModal(false)
      setLockedButtons(false)
      infoMessage('error')
    }
  }

  return (
    <Form onSubmit={handleSubmit} className={'animated fadeIn'}>
      {props.schema.hub !== 'ecommerce' && <Nav tabs className='border-bottom-0'>
        {credentials.map((crendential, index) => (
          <NavItem key={index}>
            <NavLink
              onClick={() => {
                setActiveTab(index)
                setCredential(credentials[index])
                setErrors({})
              }}
              active={activeTab === index}
            >
              <h6>
                {' '}
                {crendential.description || I18n.t('dashboard_new-female')}
              </h6>
            </NavLink>
          </NavItem>
        ))}
        <NavItem>
          <NavLink className='add-tab-button' onClick={handleAddTab} disabled={userCanReadOnly} hidden={!credentials.length}>
            <i className='fa fa-plus' />
          </NavLink>
        </NavItem>
      </Nav>}
      <TabContent activeTab={activeTab} className='rounded-bottom rounded-right'>
        <TabPane tabId={activeTab}>
          <Row>
            <Col xs={8} />
            <Col xs={4}>
              <FormGroup>
                {props.schema.hub !== 'ecommerce' && <Row>
                  <Col xs={3} />
                  <Col xs={3} className={'pr-0'}>
                    <CustomInput
                      id='isEnabled'
                      type='switch'
                      name='isEnabled'
                      className={'ml-2'}
                      disabled={userCanReadOnly}
                      checked={credential.isEnabled || false}
                      value={credential.isEnabled || false}
                      onChange={({ target }) =>
                        setCredential({
                          ...credential,
                          [target.name]: target.checked,
                        })
                      }
                    />
                  </Col>
                  <Col xs={6} className={'pl-0'}>
                    <Label for={'isEnabled'}>{I18n.t(`dashboard_${credential.isEnabled ? 'enabled' : 'disabled'}`)}</Label>
                  </Col>
                </Row>}
              </FormGroup>
            </Col>
          </Row>
          {props.schema.hub !== 'ecommerce' && <Row>
            <Col xs={2} />
            <Col xs={8}>
              <FormGroup>
                <Label for='description'>{I18n.t('dashboard_label')}</Label>
                <Input
                  type='text'
                  name='description'
                  value={credential.description || ''}
                  onChange={({ target }) =>
                    setCredential({
                      ...credential,
                      [target.name]: target.value,
                    })
                  }
                  disabled={lockedButtons || credential.inheritedFrom}
                />
              </FormGroup>
            </Col>
            <Col xs={2} />
          </Row>}
          {Object.keys(schema).length &&
            Object.keys(schema).map((input, i) => {
              if (input === 'paymentType') {
                return (
                  <Row className='justify-content-center' key={`${credential._id}-${i}`}>
                    <Col xs={2} />
                    <Col xs={8}>
                      <FormGroup>
                        <Label for={schema[input].prop}>{I18n.t(schema[input].text)}</Label>
                        <Select
                          value={
                            credential.value.paymentType
                              ? {
                                value: credential.value.paymentType,
                                label: credential.value.paymentType,
                              }
                              : config.paymentType || credential.value.paymentType
                          }
                          disabled={lockedButtons || credential.inheritedFrom}
                          styles={{
                            control: (styles) => ({
                              ...styles,
                              borderColor: errors[input] ? 'red' : styles.borderColor,
                            }),
                          }}
                          options={schema[input].options.map((item) => ({
                            value: item,
                            label: item,
                          }))}
                          onChange={(paymentType) => {
                            setConfig({ ...config, paymentType })
                            handleChange({
                              target: {
                                name: 'paymentType',
                                value: paymentType.value,
                              },
                            })
                          }}
                        />
                        <FormFeedback>{errors[input] ? I18n.t('dashboard_errors_required-field') : ''}</FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col xs={2} />
                  </Row>
                )
              } else {
                return (
                  <Row className='justify-content-center' key={`${credential._id}-${i}`}>
                    <Col xs={2} />
                    <Col xs={8}>
                      <FormGroup hidden={schema[input].hidden}>
                        <Label for={schema[input].prop}>{I18n.t(schema[input].text)}</Label>
                        {schema[input].field === 'password'
                          ? (
                            <>
                              <Input
                                type={showPassword ? 'text' : 'password'}
                                name={schema[input].prop}
                                onChange={handleChange}
                                value={credential.value[input] || schema[input].value || ''}
                                invalid={errors[input]}
                                disabled={lockedButtons || credential.inheritedFrom}
                              ></Input>
                              <i
                                onClick={() => setShowPassword(!showPassword)}
                                className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'} toggle-password`}
                              ></i>
                            </>
                          )
                          : schema[input].field === 'editor'
                            ? (
                              <TextEditor2
                                id={`answer-${props.index}`}
                                cols={5}
                                rows={7}
                                limit={0}
                                value={credential.value[input] ? credential.value[input].content : schema[input].value || schema[input].content || ''}
                                buttons={credential.value[input] ? credential.value[input].buttons : []}
                                onChange={(e) => {
                                  const data = {
                                    content: e.value,
                                    contentHtml: e.valueHtml,
                                    removeEmojisAndAccents: e.removeEmojisAndAccents
                                  }

                                  setCredential({
                                    ...credential,
                                    value: { ...credential.value, [input]: data },
                                  })
                                }}
                                minHeight={118}
                                maxHeight={null}
                                options={["emojis"]}
                                isTemplateValue
                                classNameWrapper={errors[input] ? 'is-invalid red-border' : ''}
                              />
                            )
                            : (
                              <Input
                                type={schema[input].field}
                                name={schema[input].prop}
                                onChange={handleChange}
                                value={credential.value[input] || schema[input].value || ''}
                                invalid={errors[input]}
                                disabled={lockedButtons || credential.inheritedFrom}
                              ></Input>
                            )}
                        <div className='invalid-feedback'>
                          {errors[input] ? I18n.t('dashboard_errors_required-field') : ''}
                        </div>
                      </FormGroup>
                    </Col>
                    <Col xs={2} />
                  </Row>
                )
              }
            })}
          <Row>
            <Col xs={2} />
            <Col xs={8}>
              <label hidden={status.hidden}>
                <strong className={status.css}>{status.message}</strong>
              </label>
            </Col>
            <Col xs={2} />
          </Row>

          {props.schema.key === 'api_intermundial' && credential.listPolicies && (
            <InsuranceOptions
              credential={credential}
              lockedButtons={lockedButtons || credential.inheritedFrom}
              onSelectInsurance={(name, value) =>
                setCredential({
                  ...credential,
                  configuration: {
                    ...credential.configuration,
                    insurances: { ...credential.configuration.insurances, [name]: value },
                  },
                })
              }
            />
          )}

          <Row className='my-3'>
            <Col className='text-right'>
              <Button
                color='default'
                className='mr-3 px-2 py-1'
                onClick={props.onToggleActive}
                disabled={(lockedButtons && lockedInherit) || userCanReadOnly}
              >
                {I18n.t('dashboard_cancel')}
              </Button>

              {props.schema.hub !== 'ecommerce'
                ? <Button type='submit' color='primary' className='px-2 py-1' disabled={(lockedButtons && lockedInherit) || userCanReadOnly}>
                  {I18n.t('dashboard_save')}
                </Button>
                : <Button
                  color='primary'
                  className='px-2 py-1'
                  disabled={(lockedButtons && lockedInherit) || userCanReadOnly}
                  onClick={ecommerceCredentialHandler}
                >
                  {I18n.t('dashboard_save')}
                </Button>
              }
            </Col>
          </Row>
        </TabPane>
        <Button
          className='delete-tab-button'
          disabled={lockedButtons && lockedInherit}
          color='danger'
          onClick={(e) => setShowModal(true)}
          hidden={!credentials.length || credential.inheritedFrom}
        >
          {I18n.t('dashboard_delete')}
        </Button>
        <Modal isOpen={showModal} toggle={() => setShowModal(!showModal)} className='modal-sm'>
          <ModalBody>
            <Row>
              <Col>
                <label className='text-center'>
                  {
                    getTextToDisplay(isEcommerce, modules)
                  }
                </label>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Container className='m-0 p-0'>
              <Row noGutters>
                <Col sm={6} className='text-left'>
                  <Button color='primary' size={'sm'} onClick={() => setShowModal(false)}>
                    {I18n.t('dashboard_close')}
                  </Button>
                </Col>
                <Col sm={6} className='text-right'>
                  <Button size={'sm'} color='danger' onClick={(e) => onDeleteTab(e, activeTab)}>
                    {I18n.t('dashboard_delete')}
                  </Button>
                </Col>
              </Row>
            </Container>
          </ModalFooter>
        </Modal>
      </TabContent>
    </Form>
  )
}

function getTextToDisplay(isEcommerce, modules) {
  if (!isEcommerce) return I18n.t('dashboard_youre-sure')

  if (modules?.pluginEcommerce?.isActive || modules?.smartChatEcommerce?.isActive) {
    return I18n.t('modal_plugin_removal_warning')
  }

  return I18n.t('dashboard_youre-sure')
}